import React, { createContext, useContext } from "react";

const MobileDrawerContext = createContext({
  isMobile: false,
  openMobileDrawer: () => {},
});

export function MobileDrawerProvider({ isMobile, openMobileDrawer, children }) {
  return (
    <MobileDrawerContext.Provider value={{ isMobile, openMobileDrawer }}>
      {children}
    </MobileDrawerContext.Provider>
  );
}

export function useMobileDrawer() {
  return useContext(MobileDrawerContext);
}
